import Breadcrumbs from "components/Common/Breadcrumb"
import { notificationsStatus } from "components/Common/constants"
import BackButton from "components/Shared/BackButton"
import formatDateTime from "components/Shared/formatDateTime"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { Badge, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { getPushNotificationDetails } from "store/actions/pushNotificationAction"

const AppNotificationDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t(`Notification Details `)

  const location = useLocation()
  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, pushNotificationDetails } = useSelector(
    state => state.PushNotifications
  )

  useEffect(() => {
    const fetchOldDetails = () => {
      const payload = {
        id,
      }
      dispatch(getPushNotificationDetails(payload))
    }
    fetchOldDetails()
  }, [])

  const renderNotificationType = actionType => {
    return notificationsStatus[actionType] || ""
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <BackButton /> {t("App Notification Details")}
                </CardTitle>
                <p className="text-muted mb-4"></p>
                <div className="table-responsive">
                  {loading ? (
                    <ShimmerThumbnail height={650} rounded />
                  ) : Object.values(pushNotificationDetails).length === 0 ? (
                    <p className="text-center my-3">
                      {t("No app notification details found")}
                    </p>
                  ) : (
                    <Table className="table-nowrap mb-0 capitalize_td">
                      <tbody>
                        <tr>
                          <th scope="row">{t("Id")}</th>
                          <td>{pushNotificationDetails._id}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Title(English)")}</th>
                          <td>{pushNotificationDetails?.title?.en}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Title(عربي)")}</th>
                          <td>{pushNotificationDetails?.title?.ar}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Body(English)")}</th>
                          <td>{pushNotificationDetails?.body?.en}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Body(عربي)")}</th>
                          <td>{pushNotificationDetails?.body?.ar}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Status")}</th>
                          <td>
                            {pushNotificationDetails?.status === 1 ? (
                              <Badge className="bg-success">
                                {t("Active")}
                              </Badge>
                            ) : (
                              <Badge className="bg-danger">
                                {t("Deactive")}
                              </Badge>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Notification Type")}</th>
                          <td>
                            {(pushNotificationDetails.type === "ORDER_STATUS" &&
                              t("Order")) ||
                              "-"}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Order Status")}</th>
                          <td>
                            {pushNotificationDetails.type === "ORDER_STATUS" &&
                              t(renderNotificationType(
                                pushNotificationDetails.actionType
                              ))}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Created At")}</th>
                          <td>
                            {formatDateTime(
                              pushNotificationDetails?.createdAt
                            ) || "-"}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Updated At")}</th>
                          <td>
                            {formatDateTime(
                              pushNotificationDetails?.updatedAt
                            ) || "-"}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AppNotificationDetails
